import HttpService from "../http.services";

const apiManagementService = new HttpService(process.env.REACT_APP_API_URL);

// Enviar y marcar leído van por websocket (components/chat/conexionChat.js); esto es lo
// que se consulta o se hace de vez en cuando. Los archivos se suben directo al almacén
// del chat (Cloudflare) con el permiso que da prepararAdjunto.
class ChatServiceGlobal {
  // Si el chat está configurado y qué archivos acepta.
  estado = async () => apiManagementService.post("/apiglobal/v1/chat/estado", {});

  conversaciones = async () => apiManagementService.post("/apiglobal/v1/chat/conversaciones", {});

  mensajes = async (payload = {}) => apiManagementService.post("/apiglobal/v1/chat/mensajes", payload);

  usuarios = async () => apiManagementService.post("/apiglobal/v1/chat/usuarios", {});

  crearGrupo = async (payload = {}) => apiManagementService.post("/apiglobal/v1/chat/grupos/crear", payload);

  agregarAGrupo = async (payload = {}) => apiManagementService.post("/apiglobal/v1/chat/grupos/agregar", payload);

  salirDeGrupo = async (payload = {}) => apiManagementService.post("/apiglobal/v1/chat/grupos/salir", payload);

  prepararAdjunto = async (payload = {}) => apiManagementService.post("/apiglobal/v1/chat/adjuntos/preparar", payload);

  // Configuraciones > Chat interno (solo Super Administrador).
  configuracion = async () => apiManagementService.post("/apiglobal/v1/configuracion/chat", {});

  guardarConfiguracion = async (payload = {}) => apiManagementService.post("/apiglobal/v1/configuracion/chat/guardar", payload);
}

const chatServiceGlobalInstance = new ChatServiceGlobal();

export default chatServiceGlobalInstance;
